import { atom } from 'jotai'

/**
 * The preset tour: walks a user through building an order (pick an instrument from a
 * market-data widget → enter a quantity → save it with the star). Started from the "+" in
 * PresetWidget and from the tutorial hub. See features/dashboard/components/preset-tour.tsx.
 *
 * The running tour is ephemeral — each run is an explicit ask. Only whether it was finished
 * once is kept (presetTourDoneAtom), for the hub.
 */
export type PresetTourStep = 'select-order' | 'quantity' | 'save'

export interface PresetTourState {
  step: PresetTourStep
  /** The resolved order-form card id the tour is watching for progress. */
  cardId: string
}

export const presetTourAtom = atom<PresetTourState | null>(null)

// data-preset-tour-target values the tour points at — centralized here so the widgets that
// render them and the tour that queries them can't drift apart.
export const PRESET_TOUR_TARGET = {
  orderSource: 'order-source',
  quantity: 'order-quantity',
  saveStar: 'save-star',
} as const

// ComponentKeys (COMPONENT_REGISTRY) whose WidgetShell should be tagged as an
// 'order-source' coach-mark target during the 'select-order' tour step — any
// widget a user can pick an instrument from to start building an order.
export const PRESET_TOUR_SOURCE_COMPONENT_KEYS = new Set([
  'watchlist',
  'ticker',
  'price-chart',
  'positions',
])

/** The user has finished the preset tour once. Synced per user by useGuidesSync. */
export const presetTourDoneAtom = atom(false)
